
import Upload from '@/components/UploadImage'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
name: 'Order',
components: {
Card,
Group,
Cell,
Upload
},
data() {
return {
ID: '',
order: {},
orderFiles: [],
demageFiles: [],
transferFilesMap: {},
transfer_list: [],
}
},
created() {
this.ID = this.$route.query.ID || ''
this.loadData()
},
methods: {
loadData() {
let _this = this
_this.$vux.loading.show()
let url = 'Trans.ashx?action=Form_Load'
this.$post(url, {
ID: this.ID
}).then(
response => {
_this.order = response
_this.$vux.loading.hide()
_this.getOrderFiles()
}
).catch(
response => {
console.log(response, '请求失败')
}
)
},
getOrderFiles() {
let _this = this;
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.ps_order, res => {
_this.orderFiles = res
});
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.ps_demage, res => {
_this.demageFiles = res
});
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.transfer, res => {
res.forEach(function(item) {
if (!_this.transferFilesMap.hasOwnProperty(item.DOC_GUID)) {
_this.transferFilesMap[item.DOC_GUID] = [];
}
_this.transferFilesMap[item.DOC_GUID].push(item)
})
_this.getTransferLog();
});
},
getTransferLog() {
let _this = this
_this.$vux.loading.show()
let url = 'Trans_Log.ashx?action=Form_Query'
this.$post(url, {
ID: this.ID,
TYPE: 1,
EVT_CODE: 7
}).then(
response => {
_this.transfer_list = response
_this.$vux.loading.hide()
}
).catch(
response => {
console.log(response, '请求失败')
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/ys/sh/Files.vue